import type { LogsShipEntry } from './logs.models';

/** Placeholder catalogue until GET `/api/logs` is wired. */
export const LOGS_MOCK_SHIPS: readonly LogsShipEntry[] = [
  {
    id: 'stolt-capability',
    shipName: 'Stolt Capability',
    lastUpdatedLabel: '27 Feb 2026, 15:45',
    lastUpdatedAt: '2026-02-27T15:45:00',
    userDisplayName: 'Elle Lee (EEL)',
    userInitials: 'EEL',
    voyages: [
      {
        voyageNo: '23',
        changes: [
          {
            id: 'cap-v23-audit',
            verb: 'Increased',
            factorName: 'Ship audit count',
            fromValue: '50',
            toValue: '55',
            reasonText: null,
          },
        ],
      },
    ],
  },
  {
    id: 'stolt-achievement',
    shipName: 'Stolt Achievement',
    lastUpdatedLabel: '27 Feb 2026, 15:45',
    lastUpdatedAt: '2026-02-27T15:45:00',
    userDisplayName: 'Elle Lee (EEL)',
    userInitials: 'EEL',
    voyages: [
      {
        voyageNo: '23',
        changes: [
          {
            id: 'ach-v23-audit',
            verb: 'Increased',
            factorName: 'Ship audit count',
            fromValue: '50',
            toValue: '55',
            reasonText: null,
            relatedFactors: [
              {
                factorName: 'Captain audit count',
                fromValue: '12',
                toValue: '14',
              },
            ],
          },
          {
            id: 'ach-v23-manning-1',
            verb: 'Changed',
            factorName: 'Manning agent',
            fromValue: 'ABCD',
            toValue: 'LAPA',
            reasonText: null,
          },
          {
            id: 'ach-v23-manning-2',
            verb: 'Changed',
            factorName: 'Manning agent',
            fromValue: 'ABCD',
            toValue: 'WXYZ',
            reasonText: null,
          },
          {
            id: 'ach-v23-training',
            verb: 'Increased',
            factorName: 'Captain training course count',
            fromValue: '3',
            toValue: '4',
            reasonText: null,
          },
        ],
      },
      {
        voyageNo: '24',
        changes: [
          {
            id: 'ach-v24-days',
            verb: 'Decreased',
            factorName: 'Days since last audit',
            fromValue: '180',
            toValue: '120',
            reasonText: null,
          },
        ],
      },
    ],
  },
  {
    id: 'stolt-express',
    shipName: 'Stolt Express',
    lastUpdatedLabel: '26 Feb 2026, 09:12',
    lastUpdatedAt: '2026-02-26T09:12:00',
    userDisplayName: 'James Chen (JCH)',
    userInitials: 'JCH',
    voyages: [
      {
        voyageNo: '12',
        changes: [
          {
            id: 'exp-v12-risk',
            verb: 'Increased',
            factorName: 'Voyage risk score',
            fromValue: '0.42',
            toValue: '0.48',
            reasonText: null,
          },
        ],
      },
    ],
  },
];

/** Row indices for logs list skeleton (`@for` track). */
export const LOGS_SKELETON_SHIP_ROWS = [0, 1, 2, 3, 4] as const;

/** Simulated initial load until GET `/api/logs` is wired. */
export const LOGS_PAGE_LOADING_MS = 500;

/** Simulated detail load until GET `/api/logs/{shipId}/assessment` is wired. */
export const LOG_ASSESSMENT_LOADING_MS = 500;

export type LogAssessmentFactorsSkeletonItemKind = 'readonly';

export type LogAssessmentFactorsSkeletonColumn = {
  readonly column?: boolean;
  items: readonly LogAssessmentFactorsSkeletonItemKind[];
};

/** Four-column adjusted-factors skeleton (read-only log assessment layout). */
export const LOG_ASSESSMENT_FACTORS_SKELETON_COLUMNS: readonly LogAssessmentFactorsSkeletonColumn[] = [
  { items: ['readonly', 'readonly', 'readonly', 'readonly', 'readonly', 'readonly'] },
  { items: ['readonly', 'readonly', 'readonly', 'readonly', 'readonly'] },
  { items: ['readonly', 'readonly', 'readonly', 'readonly'] },
  {
    column: true,
    items: ['readonly', 'readonly', 'readonly', 'readonly', 'readonly', 'readonly'],
  },
];
